import {
    CREATE_PRODUCT,
    DELETE_PRODUCT,
    GET_ALL_PRODUCT,
    GET_ID_PRODUCT,
    SEARCH_PRODUCT,
    UPDATE_PRODUCT,
    GET_ALL_CATEGORY,
    GET_ID_CATEGORY,
    CREATE_CATEGORY,
    UPDATE_CATEGORY,
    DELETE_CATEGORY
} from '@/types/productTypes';

const actionTypes = [
    { type: CREATE_PRODUCT, key: 'createProduct' },
    { type: DELETE_PRODUCT, key: 'deleteProduct' },
    { type: GET_ALL_PRODUCT, key: 'getAllProduct' },
    { type: GET_ID_PRODUCT, key: 'getIdProduct' },
    { type: SEARCH_PRODUCT, key: 'searchProduct' },
    { type: UPDATE_PRODUCT, key: 'updateProduct' },
    { type: GET_ALL_CATEGORY, key: 'getAllCategory' },
    { type: GET_ID_CATEGORY, key: 'getIdCategory' },
    { type: CREATE_CATEGORY, key: 'createCategory' },
    { type: UPDATE_CATEGORY, key: 'updateCategory' },
    { type: DELETE_CATEGORY, key: 'deleteCategory' }
];

let initialState = actionTypes.reduce((acc, { key }) => {
    acc[key] = false;
    acc[`err${key.charAt(0).toUpperCase() + key.slice(1)}`] = false;
    return acc;
}, {});

const productSlice = (state = initialState, action) => {
    const acc = actionTypes.find((item) => item.type === action.type);
    if (!acc) return state;
    return {
        ...state,
        [acc.key]: action?.payload?.data,
        [`err${acc.key.charAt(0).toUpperCase() + acc.key.slice(1)}`]: action?.payload?.errorMessage
    };
};

export default productSlice;
